import { create } from 'zustand';

// Mock user for demo
const DEMO_USERS = {
  'admin@company.com': {
    password: 'admin123',
    user: { _id: '1', name: 'Admin User', firstName: 'Admin', lastName: 'User', email: 'admin@company.com', phone: '+91 9876543210', role: 'admin', status: 'Active', createdAt: new Date().toISOString() }
  },
  'owner@company.com': {
    password: 'owner123',
    user: { _id: '2', name: 'Rajesh Kumar', firstName: 'Rajesh', lastName: 'Kumar', email: 'owner@company.com', phone: '+91 9876543211', role: 'owner', status: 'Active', createdAt: new Date().toISOString() }
  },
  'sales@company.com': {
    password: 'sales123',
    user: { _id: '3', name: 'Priya Sharma', firstName: 'Priya', lastName: 'Sharma', email: 'sales@company.com', phone: '+91 9876543212', role: 'sales_executive', status: 'Active', createdAt: new Date().toISOString() }
  },
  'manager@company.com': {
    password: 'manager123',
    user: { _id: '4', name: 'Arun Singh', firstName: 'Arun', lastName: 'Singh', email: 'manager@company.com', phone: '+91 9876543213', role: 'store_incharge', status: 'Active', createdAt: new Date().toISOString() }
  },
  'designer@company.com': {
    password: 'design123',
    user: { _id: '5', name: 'Meera Patel', firstName: 'Meera', lastName: 'Patel', email: 'designer@company.com', phone: '+91 9876543214', role: 'designer', status: 'Active', createdAt: new Date().toISOString() }
  },
  'pm@company.com': {
    password: 'pm123',
    user: { _id: '6', name: 'Vikram Nair', firstName: 'Vikram', lastName: 'Nair', email: 'pm@company.com', phone: '+91 9876543215', role: 'designer', status: 'Active', createdAt: new Date().toISOString() }
  },
  'inventory@company.com': {
    password: 'inv123',
    user: { _id: '7', name: 'Suresh Reddy', firstName: 'Suresh', lastName: 'Reddy', email: 'inventory@company.com', phone: '+91 9876543216', role: 'store_incharge', status: 'Active', createdAt: new Date().toISOString() }
  },
  'accounts@company.com': {
    password: 'acc123',
    user: { _id: '8', name: 'Anita Joshi', firstName: 'Anita', lastName: 'Joshi', email: 'accounts@company.com', phone: '+91 9876543217', role: 'accountant', status: 'Active', createdAt: new Date().toISOString() }
  },
};

export const useAuthStore = create((set, get) => ({
  user: null,
  token: null,
  isAuthenticated: false,

  login: (user, token) => {
    if (user && (user.name === 'SD Owner' || user.name === 'sd owner')) {
      user.name = 'Space Designs Owner';
    }
    localStorage.setItem('company_token', token);
    localStorage.setItem('company_user', JSON.stringify(user));
    set({ user, token, isAuthenticated: true });
  },

  logout: () => {
    localStorage.removeItem('company_token');
    localStorage.removeItem('company_user');
    set({ user: null, token: null, isAuthenticated: false });
  },

  hasRole: (roles) => {
    const { user } = get();
    return user ? roles.includes(user.role) : false;
  },
}));

export { DEMO_USERS };

// Rehydrate from localStorage
const storedToken = localStorage.getItem('company_token');
const storedUser = localStorage.getItem('company_user');
if (storedToken && storedUser) {
  try {
    let user = JSON.parse(storedUser);
    if (user && (user.name === 'SD Owner' || user.name === 'sd owner')) {
      user.name = 'Space Designs Owner';
      localStorage.setItem('company_user', JSON.stringify(user));
    }
    useAuthStore.getState().login(user, storedToken);
  } catch {}
}




